"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldMultilanguage = exports.localeLabels = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const locale_1 = require("../../../../utils/locale");
const legacy_1 = require("../../../Tabs/legacy");
const index_1 = require("../index");
require("./index.scss");
const className = 'form-field-multilanguage';
exports.localeLabels = {
    en: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Form/FieldMultilingual/Locale:en', defaultMessage: 'EN' })),
    de: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Form/FieldMultilingual/Locale:de', defaultMessage: 'DE' })),
    fr: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Form/FieldMultilingual/Locale:fr', defaultMessage: 'FR' })),
    sq: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Form/FieldMultilingual/Locale:sq', defaultMessage: 'AL' })),
};
class FormFieldMultilanguage extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.handleInputChange = (event, locale) => {
            const name = event.target.name;
            const updatedValue = {
                ...this.props.value,
                ...{
                    [locale]: event.target.value,
                },
            };
            this.props.onChange(name, updatedValue);
        };
        this.handleOnTabChange = (index) => {
            const locale = this.getLocaleByIndex(index);
            if (locale !== undefined && this.props.onSetActiveLocale) {
                this.props.onSetActiveLocale(locale);
            }
        };
        this.getIndexByLocale = (locale) => {
            if (!locale)
                return undefined;
            return locale_1.allLocales.includes(locale) ? locale_1.allLocales.indexOf(locale) : undefined;
        };
        this.getLocaleByIndex = (index) => {
            var _a;
            if (index === undefined)
                return undefined;
            return (_a = locale_1.allLocales[index]) !== null && _a !== void 0 ? _a : undefined;
        };
    }
    render() {
        const { activeLocale, onSetActiveLocale, value, onChange, localeErrors, error, ...restProps } = this.props;
        const isErrorDisplayed = (!Boolean(localeErrors === null || localeErrors === void 0 ? void 0 : localeErrors.length) || !activeLocale || (localeErrors === null || localeErrors === void 0 ? void 0 : localeErrors.includes(activeLocale)));
        const mapTabContent = (locale) => {
            var _a;
            return (react_1.default.createElement("div", { className: `${className}__tab-content` },
                react_1.default.createElement("div", { className: `${className}__field` },
                    react_1.default.createElement(index_1.FormField, { onChange: (e) => {
                            this.handleInputChange(e, locale);
                        }, value: (_a = value[locale]) !== null && _a !== void 0 ? _a : '', error: isErrorDisplayed ? error : undefined, ...restProps }))));
        };
        return (react_1.default.createElement(legacy_1.LegacyTabs, { tabs: locale_1.allLocales.map(locale => ({
                title: exports.localeLabels[locale],
                content: mapTabContent(locale),
                hasError: localeErrors === null || localeErrors === void 0 ? void 0 : localeErrors.includes(locale),
            })), activeTab: this.getIndexByLocale(activeLocale), onTabChange: this.handleOnTabChange, modificators: ['languages'] }));
    }
}
exports.FormFieldMultilanguage = FormFieldMultilanguage;
FormFieldMultilanguage.defaultProps = {
    value: {},
    onChange: () => { },
};
//# sourceMappingURL=index.js.map